<template>
  <div v-if="project != null">
    <h1>INFORMACIÓN SOBRE LA VIVIENDA</h1>
    <table class="table">
      <thead>
      </thead>
      <tbody>
        <tr>
          <tD>
            <b-form-group label="A.TIPO"> 
              <b-form-radio-group id="radio-group-1" v-model="project.living_type" :options="livingTypes" name="living_type" value-field="id" text-field="name">
              </b-form-radio-group>
            </b-form-group>
          </tD>
          <td>
            <b-form-group label="A.TIPO"> 
              <b-form-radio-group id="radio-group-1" v-model="project.living_property" :options="selects.living_property" name="living_property" value-field="id" text-field="name">
              </b-form-radio-group>
            </b-form-group>
          </td>
        </tr>
      </tbody>
    </table>
    <hr>
    <div class="row">
      <div class="col-sm-3">Concepto general de la vivienda</div>
      <div class="col-md-9">
        <textarea class="form-control" v-model="project.living_concept" id="project_living_concept"></textarea>
        <span class="help-block">Ingrese el concepto de vivienda del aspirante</span>
      </div>      
    </div>
    <hr>
    <div class="row">
      <div class="col-sm-3">Dirección</div>
      <div class="col-md-9">
        <div class="row">
          <div class="col-sm-12">
            <gmap-autocomplete v-model="this.project.address" @place_changed="setPlace" class="autocomplete form-control"></gmap-autocomplete>
            <p class="ubication">{{project.address}}, [{{project.latitude}},{{project.longitude}}]</p>
          </div>
        </div>        
      </div>      
    </div>
    <hr>
    <div class="row">
      <div class="col-sm-3">Mapa de ubicación</div>
      <div class="col-sm-9">
        <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
          <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" @click="center=m.position"></gmap-marker>
        </gmap-map>
      </div>
    </div>
    <hr>
    <div class="row">
      <label class="col-md-3">Concepto del sector</label>
      <div class="col-md-9">
        <textarea class="form-control" v-model="project.surrounding_concept" id="project_surrounding_concept"></textarea>
        <span class="help-block">Ingrese el concepto del sector de la vivienda del aspirante</span>
      </div>
    </div>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: 'VisitResult',
  props: ['project_id', 'assignment_id'],
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
      typeMessage: '',
      livingTypes: [
        { id: 1, name: 'Casa'},
        { id: 2, name: 'Habitación'},
        { id: 3, name: 'Apartamento'},
        { id: 4, name: 'Otro'}
      ],
      map: null,
      updateMap: true,
      center: {lat: 4.355, lng: -74.045},
      markers: [],
      places: [],
      currentPlace: null      
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker()
    },
    setLocation(){
      this.$refs.inputSearch = this.project.address
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers[0] = { position: marker };
        this.places[0] = this.currentPlace;
        this.center = marker;
        this.project.address = this.currentPlace.formatted_address
        this.project.latitude = marker.lat
        this.project.longitude = marker.lng
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },    
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProjectId(this.project_id)
          this.changeAssignmentId(this.assignment_id)
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references
      delete project.family_sicks
      delete project.working_condition
      delete project.laboral_references
      delete project.family_interviews
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
    }
  },
  created () {

  },
  watch: {
    data(newValue, oldValue) {
      
    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  },
  mounted() {
    this.geolocate();
  }
}
</script>

<style scoped>
#map {
  height: 300px;
}
.ubication{
  font-size: small;
}
</style>